import React from "react";
import ModalWrapper, { ModalSize, SaveButton } from "./Modal";
import { Journey } from "./useJourney";
import { Button } from "react-bootstrap";
import { ModalState } from "./useModalState";

interface JourneyModalProps {
    journey: Journey<unknown>;
    modalState?: ModalState<unknown>;
    title: string;
    async?: boolean;
    advanceButtonText?: string;
    isAdvanceButtonDisabled?: boolean;
    cancelButtonText?: string;
    isCancelButtonDisabled?: boolean;
    backButtonText?: string;
    children: React.ReactNode;
    nextButtonText?: string;
    isBackButtonDisabled?: boolean;
    onCancel?(): void;
    size?: ModalSize;
    className?: string;
}

const JourneyModal: React.FC<JourneyModalProps> = React.memo(props => {

    function handleCancel() {
        props.modalState?.hide();
        if (props.onCancel != null) props.onCancel();
    }

    return <ModalWrapper title={props.title} className={props.className}
        size={props.size}
        onAdvance={null}
        onCancel={handleCancel}
        async={props.async}
        footer={<JourneyFooter {...props} />}>
        {props.children}
    </ModalWrapper>
})

const JourneyFooter: React.FC<JourneyModalProps> = React.memo(props => {

    function handleCancel() {
        props.modalState?.hide();
        if (props.onCancel != null) props.onCancel();
    }

    return <>
        {props.journey.canGoBack && <Button variant="secondary"
            disabled={props.isBackButtonDisabled}
            onClick={props.journey.goBack}>
            {props.backButtonText ?? "Back"}
        </Button>}

        <Button variant="secondary"
            disabled={props.isCancelButtonDisabled}
            onClick={handleCancel}>
            {props.cancelButtonText ?? "Cancel"}
        </Button>

        <SaveButton onClick={props.journey.goForward}
            isDisabled={props.isAdvanceButtonDisabled}
            text={props.journey.canGoForward ? (props.nextButtonText ?? "Next") : props.advanceButtonText}
            async={props.async && !props.journey.canGoForward} />
    </>;
})

export default JourneyModal;